/* eslint-disable no-restricted-properties */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */

'use-strict';

import { IScope } from 'angular';
import { ChartData } from 'chart.js';
import moment from 'moment';
import { NgTableParams } from 'ng-table';
import { SurveyAPIService } from '../../shared/api/survey.service';
import { ConfigService } from '../../shared/config/config.service';
import { InterfaceService } from '../../shared/interface/interface.service';
import { TableService } from '../../shared/tables/table.service';
import { UsersService } from '../../shared/users/users.service';
import { Survey } from '../../src/app/@shared-types/surveys';
import { ESurveyState } from '../../src/app/@shared-types/surveys/enums';
import { ToastService, ToastType } from '../../ui-components/toast/toast.service';

interface SurveyScope extends IScope {
  table: NgTableParams<Survey>,
  surveys: null | Survey[],
  overlay: {
    visibility: boolean,
  },
  survey: {
    sending: boolean,
    email: string,
    customer: string,
    vehicleId: string,
  },
  twoStepDelete: boolean,
  filteredTableData: Survey[],
  userFilter: { [key: string]: string },
  stateFilter: { [key: string]: string },
  kpis: {
    error: boolean,
    nps: string,
    surveys: number,
    surveysSkipped: number,
    responses: number,
    errors: number,
    averageRecommendation: string,
    averageSatisfaction: string,
    active: boolean,
    data: number[],
  },
  hideEditOverlay: () => void,
  exportDataset: () => void,
  openEditOverlay: () => void,
  sendSurvey: () => void,
  deleteSurvey: (surveyId: string) => void,
  removeAllFilter: () => void,
  removeFilter: (filter: unknown) => void,
  chartInputChange: () => void,
  subSelectChange: () => void,
  chart: {
    total: number,
    filter: {
      mode: 'make' | 'model' | 'userId',
      dateFrom: Date | null,
      dateUntil: Date | null,
      subSelectModel: string,
      subSelectOptions: { [key: string]: string } | null,
      subSelectPlaceholder: string,
    },
    comparisonData: ChartData
  }
}

/* @ngInject */
export default function SurveyController(
  $scope: SurveyScope,
  surveyApiService: SurveyAPIService,
  NgTableParams: any,
  usersService: UsersService,
  configService: ConfigService,
  tableService: TableService,
  interfaceService: InterfaceService,
  toastService: ToastService,
): void {
  $scope.surveys = null;

  $scope.overlay = {
    visibility: false,
  };

  $scope.filteredTableData = []; // Everytime the table is filtered, the filtered data is saved.

  $scope.userFilter = {};

  usersService.getUsers()
    .forEach((u) => {
      $scope.userFilter[u.id] = `${u.first_name} ${u.last_name}`;
    });

  $scope.stateFilter = {
    I: 'Umfrage verschickt',
    R: 'Antwort erhalten',
    E: 'Fehler bei Umfrage',
    P: 'Versand geplant',
    N: 'Übersprungen',
  };

  $scope.kpis = {
    error: false,
    nps: '0',
    surveys: 0,
    responses: 0,
    surveysSkipped: 0,
    errors: 0,
    averageRecommendation: '0',
    averageSatisfaction: '0',
    active: configService.get<boolean>('survey_sending_enabled') || false,
    data: [12, 19, 3, 5, 2, 3],
  };

  $scope.chart = {
    comparisonData: { datasets: [] },
    filter: {
      dateFrom: null,
      dateUntil: null,
      mode: 'userId',
      subSelectModel: '',
      subSelectOptions: {},
      subSelectPlaceholder: '',
    },
    total: 0,
  };

  const roundUpToOneDecimal = (value: number): string => {
    const precision = Math.pow(10, 1);
    const roundedValue = Math.ceil(value * precision) / precision;
    return roundedValue.toFixed(1);
  };

  const calculateNPS = (data: Survey[]): number => {
    if (!data.length) return 0;

    const promoters = data
      .filter((s) => s.recommendationScore && s.recommendationScore >= 9)
      .length;
    const detractors = data
      .filter((s) => s.recommendationScore && s.recommendationScore <= 6)
      .length;

    return ((promoters / data.length) - (detractors / data.length)) * 100;
  };

  const calculateDashboardKPIs = () => {
    const calculationData = $scope.filteredTableData.filter((s) => s.state === 'R');

    $scope.kpis.error = calculationData.length <= 1;

    const averageRecommendation = calculationData
      .reduce((a, b) => a + (b.recommendationScore || 0), 0) / calculationData.length;
    const averageSatisfaction = calculationData
      .reduce((a, b) => a + (b.satisfactionScore || 0), 0) / calculationData.length;

    $scope.kpis.nps = roundUpToOneDecimal(calculateNPS(calculationData));
    // eslint-disable-next-line max-len
    $scope.kpis.surveys = $scope.filteredTableData.filter((s) => s.state !== ESurveyState.NONE_SENT).length;
    // eslint-disable-next-line max-len
    $scope.kpis.surveysSkipped = $scope.filteredTableData.filter((s) => s.state === ESurveyState.NONE_SENT).length;
    $scope.kpis.responses = calculationData.length;
    $scope.kpis.errors = $scope.filteredTableData.filter((s) => s.state === 'E').length;
    $scope.kpis.averageRecommendation = roundUpToOneDecimal(averageRecommendation);
    $scope.kpis.averageSatisfaction = roundUpToOneDecimal(averageSatisfaction);
  };

  /**
   * Overwrite the default filter handling from ng-table.
   * @param {Object} data - All table data
   * @param {Object} filterValues - The user input for this filter
   */
  const filterCustomCarTable = (data: Survey[], filterValues: { [key: string]: string }) => {
    const filteredData = data.filter((o) => {
      let includeInResults;

      // eslint-disable-next-line prefer-const
      for (let [filterName, filterValue] of Object.entries(filterValues)) {
        includeInResults = false;

        // Filter for date
        if (filterName === 'startDate') {
          const filterStartDate = moment(filterValue, 'DD.MM.YYYY');
          const objectDate = moment(o.creationDate);

          includeInResults = objectDate.isSameOrAfter(filterStartDate);
        } else if (filterName === 'endDate') {
          const filterEndDate = moment(filterValue, 'DD.MM.YYYY');
          const objectDate = moment(o.creationDate);

          includeInResults = objectDate.isSameOrBefore(filterEndDate);
        } else if (
          (o as any)[filterName] === undefined || (o as any)[filterName] === null
        ) return false;

        filterValue = String(filterValue);
        filterValue = filterValue.toLowerCase();

        let filterValueArray: string[];

        if (filterValue.includes(',')) {
          filterValueArray = filterValue.replace(/ /g, '').split(',');
        } else {
          filterValueArray = [filterValue];
        }

        for (const filter of filterValueArray) {
          if (filter.match(/^["].*?["]/)) {
            // Check if first and last character are quotes to test for a strict match
            if (
              String((o as any)[filterName]).toLowerCase()
              === filter.substring(1, filter.length - 1)
            ) includeInResults = true;
          } else if (String((o as any)[filterName]).toLowerCase()
            .includes(filter)) includeInResults = true;
        }

        if (!includeInResults) return false;
      }

      return includeInResults;
    });

    $scope.filteredTableData = filteredData;
    calculateDashboardKPIs();
    return filteredData;
  };

  /**
   * Remove all applied filters from table
   */
  $scope.removeAllFilter = () => {
    if (!$scope.surveys) return;

    $scope.table.filter({});
    $scope.filteredTableData = $scope.surveys;
  };

  /**
   * Remove the supplied filter from the view's table.
   */
  $scope.removeFilter = (filter: unknown) => {
    delete $scope.table.filter()[filter as any];
  };

  /**
   * Export the current tables selection as csv.
   */
  $scope.exportDataset = () => {
    if (!$scope.surveys) return;

    tableService.exportDataset(
      $scope.surveys,
      'autoboard-kundenzufriedenheit',
      [],
      [],
      require('./translations/survey.json'),
    );
  };

  $scope.hideEditOverlay = () => {
    $scope.overlay.visibility = false;
  };

  $scope.openEditOverlay = () => {
    $scope.overlay.visibility = true;
  };

  const getCalculcationData = (): Survey[] => $scope.filteredTableData.filter((s) => s.state === 'R');

  /** Returns `Surveys` that correspond to the current selection of chart filters */
  const getChartData = (): Survey[] => getCalculcationData()
    .filter((s) => {
      const { mode } = $scope.chart.filter;
      if (!$scope.chart.filter.subSelectModel) return true;
      return $scope.chart.filter.subSelectModel.split(', ').includes(String(s[mode]));
    })
    .filter((s) => {
      if (!$scope.chart.filter.dateFrom) return true;
      return moment(s.creationDate).isSameOrAfter(moment($scope.chart.filter.dateFrom!));
    })
    .filter((s) => {
      if (!$scope.chart.filter.dateUntil) return true;
      return moment(s.creationDate).isSameOrBefore(moment($scope.chart.filter.dateUntil!));
    });

  /** Fill charts with filtered data */
  const calculateCharts = async () => {
    await new Promise((resolve) => setTimeout(resolve, 50));
    if (!$scope.surveys) return;

    const surveys = getChartData();
    const { mode } = $scope.chart.filter;

    $scope.chart.comparisonData.labels = ['NPS'];
    $scope.chart.comparisonData.datasets = [];

    [...new Set(surveys.map((s) => s[mode]))]
      .forEach((uniqueKey) => {
        const surveysForKey = surveys!.filter((s) => s[mode] === uniqueKey);
        const label = $scope.chart.filter.mode === 'userId' ? $scope.userFilter[uniqueKey as string] : uniqueKey;

        $scope.chart.comparisonData.datasets.push({
          data: [calculateNPS(surveysForKey)],
          label: String(label),
        });
      });

    // Trigger change detection in `ChartComponent`
    $scope.chart.comparisonData = { ...$scope.chart.comparisonData };
    $scope.chart.total = surveys.length;
  };

  $scope.chartInputChange = (): void => {
    calculateCharts();
  };

  $scope.subSelectChange = async () => {
    // Necessary otherwise mode will not be right
    await new Promise((resolve) => setTimeout(resolve, 50));
    if (!$scope.surveys) return;

    const calculationData = $scope.filteredTableData.filter((s) => s.state === 'R');

    $scope.chart.filter.subSelectOptions = null;
    $scope.chart.filter.subSelectModel = '';

    const newOptions: { [key: string]: string } = {};

    switch ($scope.chart.filter.mode) {
      case 'make':
        [...new Set(calculationData.map((s) => ({ key: s.make, value: s.make })))]
          .forEach((make) => {
            newOptions[make.key] = make.value;
          });
        $scope.chart.filter.subSelectPlaceholder = 'Marken einschränken';
        break;
      case 'model':
        [...new Set(calculationData.map((s) => ({ key: s.model, value: s.model })))]
          .forEach((model) => {
            newOptions[model.key] = model.value;
          });
        $scope.chart.filter.subSelectPlaceholder = 'Modell einschränken';
        break;
      default:
        [...new Set(calculationData.map((s) => ({
          key: s.userId, value: $scope.userFilter[s.userId],
        })))]
          .forEach((model) => {
            newOptions[model.key] = model.value;
          });
        $scope.chart.filter.subSelectPlaceholder = 'Verkäufer einschränken';
        break;
    }

    $scope.chart.filter.subSelectOptions = { ...newOptions };
    $scope.chartInputChange();
  };

  const init = () => {
    $scope.survey = {
      sending: false,
      customer: '',
      email: '',
      vehicleId: '',
    };

    $scope.overlay.visibility = false;

    $scope.table = new NgTableParams({}, {
      filterOptions: {
        filterFn: filterCustomCarTable,
      },
    });

    surveyApiService.getSurveys()
      .then((surveys) => {
        $scope.surveys = surveys;
        $scope.table.settings({
          dataset: $scope.surveys,
        });
        $scope.filteredTableData = $scope.surveys;
        calculateDashboardKPIs();
        calculateCharts();
        interfaceService.applyScope($scope);
      })
      .catch((e) => console.error(e));
  };

  $scope.sendSurvey = () => {
    const surveyRequest = {
      customerEmail: $scope.survey.email,
      customerName: $scope.survey.customer,
      vehicleId: $scope.survey.vehicleId,
      handoverDate: moment().subtract(1, 'y').toDate(),
    };

    $scope.survey.sending = true;

    surveyApiService.postSurvey(surveyRequest)
      .then(() => {
        toastService.toast(ToastType.SUCCESS, 'Befragung wurde versendet');
        init();
      })
      .catch(() => {
        $scope.survey.sending = false;
        toastService.toast(ToastType.ERROR, 'Fehler beim Versand der Befragung');
      });
  };

  $scope.deleteSurvey = (surveyId) => {
    surveyApiService.deleteSurvey(surveyId)
      .then(() => {
        init();
        $scope.twoStepDelete = false;
        toastService.toast(ToastType.SUCCESS, 'Befragung gelöscht');
      })
      .catch(() => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Löschen der Befragung');
      });
  };

  init();
}
